<template>
  <header v-if="blok" class="site-header">
    <div
      ref="nav"
      :class="
        !$store.state.visibleSectionIndex &&
        $store.state.visibleSectionName === 'Welcome'
          ? 'site-header__menu-bar--transparent'
          : 'site-header__menu-bar--white'
      "
      class="site-header__menu-bar animate"
    >
      <nuxt-link to="/" class="site-header__logo">
        <component
          :is="'a_imageSource' | dashify"
          v-if="blok.logo && blok.logo[0].image"
          v-editable="blok"
          :blok="blok.logo[0]"
          :image-url="blok.logo[0].image"
          alt=""
        />
      </nuxt-link>
      <div v-if="pageName" class="site-header__thumbnail container">
        <component
          :is="'a_link' | dashify"
          v-for="breadcrumb in pageName"
          :key="breadcrumb._uid"
          :blok="breadcrumb"
          modifier-class=""
        />
        <span v-if="$store.state.visibleSectionName">
          / {{ $store.state.visibleSectionName }}
        </span>
      </div>
      <div class="site-header__menu-open-ct">
        <a class="site-header__menu-open" @click="isMenuOpen = true">Menu</a>
      </div>
    </div>

    <transition name="fade">
      <div v-if="isMenuOpen" class="site-header__menu-content">
        <nuxt-link to="/" class="site-header__logo">
          <component
            :is="'a_imageSource' | dashify"
            v-if="blok.logo && blok.logo[0].image"
            v-editable="blok"
            :blok="blok.logo[0]"
            :image-url="blok.logo[0].image"
            alt=""
          />
        </nuxt-link>
        <div class="container site-header__menu-nav">
          <nav class="site-header__nav">
            <ul>
              <li
                v-for="(link, index) in blok.links.tbody"
                :key="link.key"
                :class="'site-header__item ' + menuItemClass + '-' + index"
              >
                <nuxt-link
                  v-if="link[1]"
                  v-editable="blok"
                  :to="link[1]"
                  class="site-header__link"
                  @click.native="
                    link[1] === $nuxt.$route.path ? (isMenuOpen = false) : false
                  "
                  ><span class="link__text" v-text="link[0]"
                /></nuxt-link>
              </li>
            </ul>
          </nav>
        </div>
        <a
          :class="menuCloseClass"
          class="site-header__menu-close"
          @click="isMenuOpen = false"
          ><span class="icon icon--close"></span
        ></a>
      </div>
    </transition>
  </header>
</template>

<script>
import { TimelineMax, Power2 } from 'gsap'

export default {
  props: {
    blok: {
      type: Object,
      default: () => {},
    },
    pageName: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      animated: false,
      isMenuOpen: false,
      menuItemClass: '',
      menuCloseClass: '',
      isWhite: false,
    }
  },
  computed: {
    getScrolledClassName() {
      return this.isWhite
        ? 'site-header__menu-bar--white '
        : 'site-header__menu-bar--transparent'
    },
  },
  watch: {
    isMenuOpen(isMenuOpen) {
      if (isMenuOpen) {
        setTimeout(() => {
          this.menuItemClass = 'site-header__item site-header__item--animate'
          this.menuCloseClass = 'site-header__menu-close--animate'
        }, 50)
      } else {
        this.menuItemClass = ''
        this.menuCloseClass = ''
      }
    },
  },
  mounted() {
    const { nav } = this.$refs

    const tl = new TimelineMax({
      delay: 0.3,
    })
    tl.set(
      [nav].filter((e) => {
        return e
      }),
      { opacity: 0 }
    ).fromTo(
      [nav].filter((e) => {
        return e
      }),
      1.5,
      { autoAlpha: 0 },
      { autoAlpha: 1, ease: Power2.easeOut }
    )
  },
}
</script>

<style lang="scss">
@import '../../assets/scss/settings';

.site-header {
  position: fixed;
  z-index: 500;
  width: 100%;
  top: 0;

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.5s;
  }
  .fade-enter,
  .fade-leave-to {
    // opacity: 0;
  }

  .animate {
    // opacity: 0;
  }

  &__logo {
    flex: 1 1 auto;
    text-align: right;

    img {
      height: 20px;
      margin-right: 15px;
      margin-top: -11px;
      width: 20px;
    }
  }

  &__thumbnail {
    @include font-family($font-family-text);
    @include font-size(12);

    flex: 1 1 auto;
    color: $black;
    transition: color 1s ease 0.1s;

    a:hover {
      color: $oslo-gray;
    }
  }

  &__menu-open-ct {
    flex: 1 1 auto;
    position: relative;
    display: block;
    min-width: 45px;
  }

  &__menu-open {
    @include font-size(12);

    cursor: pointer;
    color: $black;
    position: absolute;
    left: 14px;

    &:hover {
      color: $oslo-gray;
    }
  }

  &__menu-close {
    cursor: pointer;
    color: $white;
    flex: 1 1 auto;
    margin-top: -2px;
    min-width: 45px;

    .icon {
      transform: rotate(45deg);
      transition: transform 0.5s ease, top 0.5s ease;
      transition-delay: 0.1s;
      display: inline-block;

      &::before {
        margin-left: 5px;
      }
    }

    &--animate {
      .icon {
        transform: rotate(0deg);
      }
    }
  }

  &__menu-bar {
    color: $black;
    display: flex;
    padding: 20px 30px;
    min-height: 68px;

    &--transparent {
      background: $gray-950;
      border-bottom: 1px solid $gray-900;

      .site-header__menu-open,
      .site-header__thumbnail a,
      .site-header__thumbnail span {
        color: $white;
      }
    }

    &--white {
      background: $white;
      border-bottom: 1px solid $gray-200;
    }
  }

  &__menu-content {
    position: fixed;
    height: 100vh;
    width: 100%;
    top: 0;
    left: 0;
    background-color: $black;
    padding: 20px 30px;
    display: flex;
  }

  &__menu-space {
    flex: 1 1 auto;
    display: block;
    min-width: 45px;
  }

  &__menu-nav {
    flex: 1 1 auto;
  }

  &__nav {
    @include font-size(36, rem-v(60));
    @include font-family($font-family-headings-bold);

    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: center;
    text-align: right;

    ul {
      padding: 0;
      margin: 0;
      list-style: none;
    }

    li {
      padding: 8px 0;
    }
  }

  &__link {
    color: $white;
  }

  &__item {
    display: block;
    opacity: 0;
    transform: translate(0, 30px);

    &--animate-0 {
      opacity: 1;
      transition: all 0.6s cubic-bezier(0.7, 0, 0.3, 1) 0.1s;
    }
    &--animate-1 {
      opacity: 1;
      transition: all 0.6s cubic-bezier(0.7, 0, 0.3, 1) 0.2s;
    }
    &--animate-2 {
      opacity: 1;
      transition: all 0.6s cubic-bezier(0.7, 0, 0.3, 1) 0.3s;
    }
    &--animate-3 {
      opacity: 1;
      transition: all 0.6s cubic-bezier(0.7, 0, 0.3, 1) 0.4s;
    }
    &--animate-4 {
      opacity: 1;
      transition: all 0.6s cubic-bezier(0.7, 0, 0.3, 1) 0.5s;
    }
    &--animate-5 {
      opacity: 1;
      transition: all 0.6s cubic-bezier(0.7, 0, 0.3, 1) 0.6s;
    }
    &--animate-6 {
      opacity: 1;
      transition: all 0.6s cubic-bezier(0.7, 0, 0.3, 1) 0.7s;
    }
    &--animate-7 {
      opacity: 1;
      transition: all 0.6s cubic-bezier(0.7, 0, 0.3, 1) 0.8s;
    }
    &--animate-8 {
      opacity: 1;
      transition: all 0.6s cubic-bezier(0.7, 0, 0.3, 1) 0.9s;
    }
    &--animate-9 {
      opacity: 1;
      transition: all 0.6s cubic-bezier(0.7, 0, 0.3, 1) 1s;
    }
  }
}

@include media-breakpoint-up(md) {
  .site-header {
    &__logo {
      img {
        height: 30px;
        margin-top: -3px;
        width: 30px;
      }
    }

    &__thumbnail {
      @include font-size(16);
    }

    &__menu-open {
      @include font-size(16);

      left: -56px;
    }

    &__menu-close {
      margin-top: 2px;
      position: relative;

      .icon {
        position: absolute;
        left: -50px;
        &::before {
          margin-left: 10px;
        }
      }
    }
  }
}
</style>
